module.exports = __webpack_public_path__ + "img/cancelled.f90d2b25.svg";